var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconTelescope2 = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.72 14.875 2.812-4.687m0 0 2.812 4.687m-2.812-4.687v4.687m5.624-5.156v2.812m-1.406-1.406h2.813M2.842 1.281v2.813M1.439 2.688H4.25M2.578 7.146l1.446-.59.71 1.736-1.448.59a.31.31 0 0 1-.407-.17l-.472-1.158a.31.31 0 0 1 .171-.408M3.96 5.57l3.183-1.299 1.417 3.472-3.183 1.299a.31.31 0 0 1-.407-.171L3.787 5.978a.313.313 0 0 1 .172-.408m8.055-4.247a.47.47 0 0 0-.653-.237L7.162 3.204a.47.47 0 0 0-.214.592l1.805 4.422a.47.47 0 0 0 .567.273l4.482-1.425a.47.47 0 0 0 .3-.625z"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.72 14.875 2.812-4.687m0 0 2.812 4.687m-2.812-4.687v4.687m5.624-5.156v2.812m-1.406-1.406h2.813M2.842 1.281v2.813M1.439 2.688H4.25M2.578 7.146l1.446-.59.71 1.736-1.448.59a.31.31 0 0 1-.407-.17l-.472-1.158a.31.31 0 0 1 .171-.408M3.96 5.57l3.183-1.299 1.417 3.472-3.183 1.299a.31.31 0 0 1-.407-.171L3.787 5.978a.313.313 0 0 1 .172-.408m8.055-4.247a.47.47 0 0 0-.653-.237L7.162 3.204a.47.47 0 0 0-.214.592l1.805 4.422a.47.47 0 0 0 .567.273l4.482-1.425a.47.47 0 0 0 .3-.625z"
  }));
});
export default SvgIconTelescope2;
export const raw = __webpack_public_path__ + "static/media/IconTelescope2.8c891b3874d5b7faf0133bfd4baf5c3f.svg";